import { render, staticRenderFns } from "./HealthyLife.vue?vue&type=template&id=2f3cded8&scoped=true&"
import script from "./HealthyLife.vue?vue&type=script&lang=js&"
export * from "./HealthyLife.vue?vue&type=script&lang=js&"
import style0 from "./HealthyLife.vue?vue&type=style&index=0&id=2f3cded8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f3cded8",
  null
  
)

export default component.exports